<template>
    <div>
        
        <b-table 
            :data="logging"
            :per-page="30"
            :total="logging.length | 0"
            :default-sort="['createdAt']"
            :narrowed="true"
            paginated>
            
            <b-table-column width="15%" field="status" label="Time" v-slot="props">
                {{ props.row.createdAt.toDate().getHours() }}:{{ props.row.createdAt.toDate().getMinutes() }} {{ props.row.createdAt.toDate().toDateString() }}
            </b-table-column>
            <b-table-column width="1%" field="level" label="Type" v-slot="props">
                <span v-if="props.row.level == 'INFO'">
                    ℹ️&nbsp;{{ props.row.level }}
                </span>
                <span v-else-if="props.row.level == 'WARNING'">
                    ⚠️&nbsp;{{ props.row.level }}
                </span>
                <span v-else>
                    {{  props.row.level  }}
                </span>
            </b-table-column>
            <b-table-column width="1%" field="status" label="Status" v-slot="props">
                <span v-if="props.row.step == 'train'">
                    🧠&nbsp;{{ props.row.step }}.{{ props.row.status }}
                </span>
                <span v-else>
                    🗂️&nbsp;{{ props.row.step }}.{{ props.row.status }}
                </span>
                
            </b-table-column>
            <b-table-column width="60%" field="msg" label="Details" v-slot="props">
                {{ props.row.msg }}
            </b-table-column>
        </b-table>
    </div>
</template>
<script>

   export default {
     props: ["projectId"],
     name: "Logging",
     data: function() {
        return {
            
        }
    },
    computed: {
        logging(){
            return this.$store.state[`logging-${this.projectId}`]
        }
     },
     created(){
        
        this.$store.dispatch("currentProjectLogging", this.projectId)
        
     }
   }
</script>